/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type InvoiceDetailsTable_project$ref = any;
export type BUDGET_TYPE = "FIXED_PRICE" | "FIXED_PRICE_V2" | "NON_BILLABLE" | "RETAINER" | "TIME_AND_MATERIALS" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type InvoiceDetails_project$ref: FragmentReference;
declare export opaque type InvoiceDetails_project$fragmentType: InvoiceDetails_project$ref;
export type InvoiceDetails_project = {|
  +budgetType: ?BUDGET_TYPE,
  +$fragmentRefs: InvoiceDetailsTable_project$ref,
  +$refType: InvoiceDetails_project$ref,
|};
export type InvoiceDetails_project$data = InvoiceDetails_project;
export type InvoiceDetails_project$key = {
  +$data?: InvoiceDetails_project$data,
  +$fragmentRefs: InvoiceDetails_project$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvoiceDetails_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budgetType",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InvoiceDetailsTable_project"
    }
  ],
  "type": "ProjectType"
};
// prettier-ignore
(node/*: any*/).hash = 'b3091e392030c9087468d1277ed3272c';

module.exports = node;
